import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-circle',
  templateUrl: './shared-circle.component.html',
  styleUrls: ['./shared-circle.component.scss']
})
export class SharedCircleComponent {

}
